import { request } from "../../apis";
import { getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency();

export const apiGetEventList = (params) =>
  request("get", `/${userCurrency}/agent/promotion`, params, true);

export const apiGetApplyRecord = (params) =>
  request("get", `/${userCurrency}/agent/promotion/record`, params, true);

export const apiApplyPromotion = (params) =>
  request("post", `/${userCurrency}/agent/promotion`, params, true);
